import { DocumentView } from "@/types/document";
import { DocumentFilter } from "./DocumentFilter";
import AppHeader from "@/components/AppHeader";

interface DocumentsHeadersProps {
  currentView: DocumentView;
  filteredDocumentsCount: number;
  selectedCourseIds: string[];
  searchQuery: string;
  onCourseFilterChange: (courseIds: string[]) => void;
  onSearchChange: (query: string) => void;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
}

export const DocumentsHeaders = ({
  currentView,
  filteredDocumentsCount,
  selectedCourseIds,
  searchQuery,
  onCourseFilterChange,
  onSearchChange,
  onSearchFocus,
  onSearchBlur,
}: DocumentsHeadersProps) => {
  const getHeader = () => {
    const count = filteredDocumentsCount;
    
    // If there's an active search query, show search-specific header
    if (searchQuery.trim()) {
      return {
        primary: `${count} submission${count !== 1 ? "s" : ""}`,
        secondary: "matching search",
      };
    }
    
    switch (currentView) {
      case "ready":
        return {
          primary: `${count} submission${count !== 1 ? "s" : ""}`,
          secondary: "awaiting grading",
        };
      case "done":
        return {
          primary: `${count} submission${count !== 1 ? "s" : ""}`,
          secondary: "graded",
        };
      case "flagged":
        return {
          primary: `${count} submission${
            count !== 1 ? "s" : ""
          }`,
          secondary: "flagged",
        };
      case "archived":
        return {
          primary: `${count} submission${
            count !== 1 ? "s" : ""
          }`,
          secondary: "archived",
        };
      default:
        return { primary: "", secondary: "" };
    }
  };

  const header =
    filteredDocumentsCount > 0 ||
    selectedCourseIds.length > 0 ||
    searchQuery.trim()
      ? getHeader()
      : null;

  if (!header) {
    return null;
  }

  return (
    <div className="flex justify-between pb-8 items-center">
      <AppHeader primary={header.primary} secondary={header.secondary} />
      <DocumentFilter
        selectedCourseIds={selectedCourseIds}
        onCourseFilterChange={onCourseFilterChange}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        onSearchFocus={onSearchFocus}
        onSearchBlur={onSearchBlur}
      />
    </div>
  );
};
